import { STATUS, useVerifyAction } from '@/providers/VerifyActionProvider';
import { Box } from '@mantine/core';
import { KycCompleteForm } from './KycCompleteForm';
import { KycCongratsInfo } from './KycCongratsInfo';
import { KycEmailSuccess } from './KycEmailSuccess';
import { KycIdVerification } from './KycIDVerification';
import { KycIdVerificationTablet } from './KycIDVerificationTablet';
import { KycRegistration } from './KycRegistration';
import { KycVerifyEmail } from './KycVerifyEmail';
export const KycRightSection: React.FC = () => {
  const {
    status,
    successes
  } = useVerifyAction();
  return <Box h="100%" style={{
    zIndex: 1
  }}>
      {status === STATUS.REGISTRATION ? <KycRegistration visible="sm" /> : status === STATUS.VERIFY_EMAIL && !successes.has(STATUS.VERIFY_EMAIL) ? <KycVerifyEmail /> : status === STATUS.VERIFY_EMAIL && successes.has(STATUS.VERIFY_EMAIL) ? <KycEmailSuccess /> : status === STATUS.COMPLETE_PROFILE ? <KycCompleteForm /> : status === STATUS.ID_VERIFICATION && !successes.has(STATUS.ID_VERIFICATION) ? <>
          <KycIdVerification />
          <KycIdVerificationTablet />
        </> : status === STATUS.ID_VERIFICATION && successes.has(STATUS.ID_VERIFICATION) ? <KycCongratsInfo /> : null}
    </Box>;
};